import { IThemeInterface } from './common';
import { amountTheme } from './amountCommon';

const theme: IThemeInterface = {
  ...amountTheme
};

export default theme;
